import { colors, font } from "../styles/theme";
import { services, NEUTRAL_SERVICE } from "../data/services";
import useLeadSubmit from "../lib/useLeadSubmit";
import usePhoneMask from "../lib/usePhoneMask";
import ConsentCheckbox from "./ConsentCheckbox";

// Форма «Бесплатный расчёт». Используется в hero 1/2/3.
// variant: "light" (на белом) | "glass" (полупрозрачная, на фото).
// button: "red" | "black" | "white" — цвет кнопки.
export default function CalcForm({ variant = "light", button = "red" }) {
  const glass = variant === "glass";
  const { status, error, errors, submit, clearFieldError } = useLeadSubmit("Форма «Расчёт» (hero)");
  const phone = usePhoneMask();

  const baseBorder = glass ? "rgba(255,255,255,.22)" : "#dde1e7";
  const field = {
    width: "100%",
    padding: "14px 16px",
    borderRadius: 11,
    fontFamily: font.body,
    fontSize: 15,
    outline: "none",
    border: "1px solid " + baseBorder,
    background: glass ? "rgba(255,255,255,.08)" : "#fff",
    color: glass ? "#fff" : colors.ink,
  };
  const errColor = glass ? "#ff9098" : colors.red;

  const btnBg = button === "black" ? colors.ink : button === "white" ? "#fff" : colors.red;
  const btnColor = button === "white" ? colors.ink : "#fff";
  const btnHover = button === "black" ? colors.red : button === "white" ? colors.red : colors.redDark;

  return (
    <div
      className="calc-form"
      style={{
        borderRadius: 18,
        padding: "30px 28px",
        height: "100%",
        background: glass ? "rgba(255,255,255,.06)" : "#fff",
        border: glass ? "1px solid rgba(255,255,255,.16)" : "1px solid #e6e9ee",
        boxShadow: glass ? "0 18px 40px rgba(0,0,0,.35)" : "0 18px 40px rgba(18,24,38,.07)",
        backdropFilter: glass ? "blur(7px)" : undefined,
        WebkitBackdropFilter: glass ? "blur(7px)" : undefined,
        transition: "backdrop-filter .6s ease, -webkit-backdrop-filter .6s ease",
      }}
    >
      <div
        style={{
          fontFamily: font.display,
          fontWeight: 700,
          fontSize: 24,
          textTransform: "uppercase",
          color: glass ? "#fff" : colors.ink,
        }}
      >
        Бесплатный расчёт
      </div>
      <div style={{ fontSize: 14, color: glass ? "#bfc4cc" : colors.muted, marginTop: 6 }}>
        Перезвоним в течение 15 минут
      </div>

      {status === "success" ? (
        <div style={{ marginTop: 22, textAlign: "center" }}>
          <div style={{ fontFamily: font.display, fontWeight: 700, fontSize: 19, textTransform: "uppercase", color: glass ? "#fff" : colors.ink }}>
            Заявка отправлена!
          </div>
          <p style={{ margin: "8px 0 0", fontSize: 14, color: glass ? "#dfe2e7" : colors.text }}>
            Перезвоним в течение 15 минут.
          </p>
        </div>
      ) : (
        <>
          <form noValidate onSubmit={(e) => submit(e)} style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 22 }}>
            <div>
              <input
                name="name"
                style={{ ...field, borderColor: errors.name ? errColor : baseBorder }}
                placeholder="Ваше имя"
                onChange={() => clearFieldError("name")}
                onFocus={(e) => (e.target.style.borderColor = colors.red)}
                onBlur={(e) => (e.target.style.borderColor = errors.name ? errColor : baseBorder)}
              />
              {errors.name && <div style={{ fontSize: 12.5, color: errColor, marginTop: 5 }}>{errors.name}</div>}
            </div>
            <div>
              <input
                name="phone"
                style={{ ...field, borderColor: errors.phone ? errColor : baseBorder }}
                type="tel"
                inputMode="tel"
                placeholder="+7 (___) ___-__-__"
                value={phone.value}
                onChange={(e) => {
                  phone.onChange(e);
                  clearFieldError("phone");
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = colors.red;
                  phone.onFocus();
                }}
                onBlur={(e) => (e.target.style.borderColor = errors.phone ? errColor : baseBorder)}
              />
              {errors.phone && <div style={{ fontSize: 12.5, color: errColor, marginTop: 5 }}>{errors.phone}</div>}
            </div>
            <select
              name="service"
              defaultValue=""
              style={{ ...field, color: glass ? "#cfd3d9" : colors.text, cursor: "pointer" }}
              onFocus={(e) => (e.target.style.borderColor = colors.red)}
              onBlur={(e) => (e.target.style.borderColor = glass ? "rgba(255,255,255,.22)" : "#dde1e7")}
            >
              <option value="" style={{ color: colors.text }}>
                Выберите услугу
              </option>
              <option style={{ color: colors.text }}>{NEUTRAL_SERVICE}</option>
              {services.map((s) => (
                <option key={s.num} style={{ color: colors.text }}>
                  {s.name}
                </option>
              ))}
            </select>
            {status === "error" && (
              <div style={{ fontSize: 13, color: glass ? "#ff9098" : colors.red }}>{error}</div>
            )}
            <ConsentCheckbox error={errors.consent} onChange={() => clearFieldError("consent")} dark={glass} style={{ marginTop: 2 }} />
            <button
              type="submit"
              disabled={status === "sending"}
              style={{
                marginTop: 4,
                background: btnBg,
                color: btnColor,
                border: "none",
                fontFamily: font.display,
                fontWeight: 600,
                fontSize: 16,
                letterSpacing: ".04em",
                textTransform: "uppercase",
                padding: 16,
                borderRadius: 11,
                cursor: status === "sending" ? "default" : "pointer",
                opacity: status === "sending" ? 0.7 : 1,
                transition: "background .18s, color .18s",
              }}
              onMouseEnter={(e) => {
                if (status === "sending") return;
                e.currentTarget.style.background = btnHover;
                e.currentTarget.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = btnBg;
                e.currentTarget.style.color = btnColor;
              }}
            >
              {status === "sending" ? "Отправляем…" : "Получить расчёт"}
            </button>
          </form>
        </>
      )}
    </div>
  );
}
